import {Address} from "@irati/types"
import {Body} from "@irati/ui/src/Typography"
import React from "react"
import {FormattedMessage} from "@irati/utils/lang"
import Flex from "@irati/ui/src/Flex"


type Props = {
  shippingAddress: Address,
  small?: boolean,
  showEmailConfirmation?: boolean
}

export const AddressInfo = ({shippingAddress, small, showEmailConfirmation}: Props) => {
  return (
    <Flex direction="column" marginLeft={2}>
      <Body small={small}>{shippingAddress.firstName} {shippingAddress.lastName}</Body>
      <Body small={small}>{shippingAddress.address1}</Body>
      {
        shippingAddress.address2 ?
          <Body small={small}>{shippingAddress.address2}</Body>
          :
          null
      }
      <Body small={small}>{shippingAddress.city}</Body>
      <Body small={small}>{shippingAddress.postalCode}</Body>
      <Body small={small}>{shippingAddress.phoneNumber}</Body>

      {showEmailConfirmation && <Flex direction="row" marginTop={4} wrap="wrap">
        <Body>
          <FormattedMessage id="flexiRewards.merchandise.checkout.emailConfirmation" />
        </Body>
        <Body marginLeft={0.5} small={small}>{shippingAddress.email}</Body>
      </Flex>}
    </Flex>
  )
}
